import app from './app';

// portuguese-brazil
export default {
  app,
};
